export default __webpack_public_path__ + "static/media/linkedin.9c787783.png";